import mixpanel from 'mixpanel-browser'
import {isAuthenticatedForAnalytics} from './analyticsAuth'

let isInitialized = false
let analyticsQueue = []

// Initialize MixPanel with user data
export const initializeMixPanel = userData => {
  if (!userData?.userInfo) return
  try {
    // Initialize MixPanel with configuration
    mixpanel.init('da6e73a731055330cc4058ad5a203843', {
      debug: process.env.NODE_ENV === 'development',
      track_pageview: true,
      persistence: 'localStorage',
      autocapture: true,
      record_sessions_percent: 80,
      loaded: mixpanel => {
        isInitialized = true
        if (userData) {
          while (analyticsQueue.length > 0) {
            const {eventName, properties} = analyticsQueue.shift()
            mixpanel.track(eventName, properties)
          }
        } else {
          analyticsQueue = []
        }
      },
    })

    // Identify user and set properties
    mixpanel.identify(userData.userInfo.Email)

    mixpanel.people.set({
      $email: userData.userInfo.Email,
      $first_name: userData.userInfo.FirstName,
      $last_name: userData.userInfo.LastName,
      role: userData.userInfo.Role,
      school_name: userData.schoolName,
      mat_group_id: userData.MatGroupId,
      school_id: userData.schoolId,
      // products: Array.isArray(userData.products)
      //   ? userData.products.map(p => p.Product).join(',')
      //   : '',
    })
  } catch (error) {
    console.error('Error initializing MixPanel:', error)
  }
}

// Initialize Usetiful with user data
export const initializeUsetiful = userData => {
  if (!userData?.userInfo) return
  try {
    // First, remove any existing Usetiful scripts
    const existingScript = document.getElementById('usetifulScript')
    if (existingScript) {
      existingScript.remove()
    }

    // Set up user identification for Usetiful BEFORE loading the script
    const usetifulTags = {
      userId: userData.userInfo.Email,
      firstName: userData.userInfo.FirstName || '',
      lastName: userData.userInfo.LastName || '',
      // Optional additional properties
      role: userData.userInfo.Role || '',
      schoolName: userData.schoolName || '',
      matGroupId: userData.MatGroupId || '',
      schoolId: userData.schoolId || '',
    }

    // Add the tags to window object
    const tagsScript = document.createElement('script')
    tagsScript.type = 'text/javascript'
    tagsScript.text = `window.usetifulTags = ${JSON.stringify(usetifulTags)};`
    document.head.appendChild(tagsScript)

    // Now add the Usetiful main script
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.text = `
      (function (w, d, s) {
        var a = d.getElementsByTagName('head')[0];
        var r = d.createElement('script');
        r.async = 1;
        r.src = s;
        r.setAttribute('id', 'usetifulScript');
        r.dataset.token = "29a2be87397f16c68660dcf9771eb56d";
        a.appendChild(r);
      })(window, document, "https://www.usetiful.com/dist/usetiful.js");
    `
    document.head.appendChild(script)
  } catch (error) {
    console.error('Error initializing Usetiful:', error)
  }
}

// Track page views using MixPanel
export const trackPageView = (pageName, properties = {}) => {
  if (!isAuthenticatedForAnalytics()) {
    return
  }

  const event = {
    eventName: 'Page View',
    properties: {page_name: pageName, ...properties},
  }

  if (!isInitialized) {
    analyticsQueue.push(event)
    return
  }

  try {
    mixpanel.track(event.eventName, event.properties)
  } catch (error) {
    console.error('Error tracking page view:', error)
  }
}

// Track events in MixPanel
export const trackEvent = (eventName, properties = {}) => {
  if (!isAuthenticatedForAnalytics()) {
    return
  }

  const event = {eventName, properties}

  if (!isInitialized) {
    analyticsQueue.push(event)
    return
  }

  try {
    mixpanel.track(eventName, properties)
  } catch (error) {
    console.error('Error tracking event:', error)
  }
}

// Initialize analytics systems
export const initializeAnalytics = userData => {
  // if (!isAuthenticatedForAnalytics()) {
  //   console.debug('Skipping analytics initialization - user not authenticated');
  //   return;
  // }

  if (!userData?.userInfo) {
    console.warn('Attempted to initialize analytics without user data')
    return
  }

  console.debug('Initializing analytics with user data:', {
    email: userData.userInfo.Email,
    role: userData.userInfo.Role,
  })

  // Initialize MixPanel first
  initializeMixPanel(userData)

  // Initialize Usetiful after a small delay to ensure tags are set
  setTimeout(() => {
    initializeUsetiful(userData)
  }, 100)
}

// Push data to data layer for potential GTM integration
export const pushDataToDataLayer = data => {
  if (!window.dataLayer) {
    window.dataLayer = []
  }
  window.dataLayer.push(data)
}
